module.exports = __webpack_public_path__ + "img/germany-cancer-male.ba70f068.png";